import { Card, CardContent } from '@/components/ui/card';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

export default function Contatti() {
  return (
    <div>
      <section className="hero-wash py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1F2A37] mb-4" style={{fontFamily:'Space Grotesk'}}>Contatti</h1>
          <p className="text-lg text-muted-foreground max-w-3xl">Siamo a tua disposizione per qualsiasi informazione</p>
        </div>
      </section>

      <section className="py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8">
            <div className="space-y-6">
              <Card><CardContent className="p-6"><div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[hsl(var(--accent))] flex items-center justify-center flex-shrink-0"><MapPin size={20} className="text-[#238A92]" /></div>
                <div><h3 className="font-semibold text-[#1F2A37] mb-1" style={{fontFamily:'Space Grotesk'}}>Indirizzo</h3><p className="text-sm text-muted-foreground">Via Settembrini 7, 20124 Milano (MI)</p><p className="text-xs text-muted-foreground mt-1">Zona Stazione Centrale - Facilmente raggiungibile con Metro M2/M3</p></div>
              </div></CardContent></Card>

              <Card><CardContent className="p-6"><div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[hsl(var(--accent))] flex items-center justify-center flex-shrink-0"><Phone size={20} className="text-[#238A92]" /></div>
                <div><h3 className="font-semibold text-[#1F2A37] mb-1" style={{fontFamily:'Space Grotesk'}}>Telefono</h3><p className="text-sm text-muted-foreground">02.6693281</p><p className="text-sm text-muted-foreground">02.67075732</p></div>
              </div></CardContent></Card>

              <Card><CardContent className="p-6"><div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[hsl(var(--accent))] flex items-center justify-center flex-shrink-0"><Mail size={20} className="text-[#238A92]" /></div>
                <div><h3 className="font-semibold text-[#1F2A37] mb-1" style={{fontFamily:'Space Grotesk'}}>Email</h3><p className="text-sm text-muted-foreground">info@studiomedicoboscovich.com</p></div>
              </div></CardContent></Card>

              <Card><CardContent className="p-6"><div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[hsl(var(--accent))] flex items-center justify-center flex-shrink-0"><Clock size={20} className="text-[#238A92]" /></div>
                <div><h3 className="font-semibold text-[#1F2A37] mb-1" style={{fontFamily:'Space Grotesk'}}>Orari di Apertura</h3>
                  <div className="text-sm text-muted-foreground space-y-1"><p>Lunedì - Venerdì: 9:00 - 19:00</p><p>Sabato: 9:00 - 13:00</p><p>Domenica: Chiuso</p></div>
                </div>
              </div></CardContent></Card>
            </div>

            <div className="rounded-2xl overflow-hidden shadow-[var(--shadow-md)] h-[500px]">
              <iframe title="Studio Medico Boscovich - Mappa" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2797.8!2d9.2!3d45.48!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786c6d2c3e3e3e3%3A0x0!2sVia+Settembrini+7%2C+Milano!5e0!3m2!1sit!2sit!4v1" width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
